var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 22.1537L15.9992 13.2922M15.9992 13.2922L19.9377 17.2307M15.9992 13.2922L12.0608 17.2307M9.10691 26.0922C5.84418 26.0922 3.19922 23.4472 3.19922 20.1845C3.19922 17.5681 4.90004 15.349 7.25636 14.5725C7.17844 14.1576 7.13768 13.7297 7.13768 13.2922C7.13768 9.48569 10.2235 6.3999 14.03 6.3999C17.2218 6.3999 19.9068 8.56947 20.6908 11.5143C21.0738 11.3901 21.4825 11.323 21.9069 11.323C24.0821 11.323 25.8454 13.0863 25.8454 15.2614C25.8454 15.7185 25.7675 16.1573 25.6244 16.5655C27.4803 17.2707 28.7992 19.0659 28.7992 21.1691C28.7992 23.8881 26.5951 26.0922 23.8761 26.0922H9.10691Z",
    stroke: "#6200EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.63b041401b693997a1eada72d9f9d7d3.svg";
export { ForwardRef as ReactComponent };